import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "checkmark-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M6 13.2L9.6 18 18 6", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
